define("ROOM4.CCAWSwiperLoader.NsNavPlugin", ["Backbone"], function (Backbone) {
  "use strict";

  function NsNavPlugin(pluginParams) {
    pluginParams.on("click", function (swiper, e) {
      var clickedLink = e.target.closest("a[data-hashtag]");
      if (!clickedLink) {
        return;
      }
      var $el = Backbone.$(clickedLink);
      var hashtag = $el.data("hashtag");
      var href = $el.attr("href");
      // Prefer data-hashtag if present
      var target = (hashtag && hashtag.toString()) || "";
      if (!target && href) {
        // Strip leading # if provided
        target = href.replace(/^#/, "");
      }
      if (target) {
        // Use Backbone router if available, otherwise fall back to hash
        try {
          if (Backbone && Backbone.history) {
            Backbone.history.navigate(target.replace(/^\//, ""), {
              trigger: true,
            });
          } else {
            window.location.hash = target;
          }
        } catch (err) {
          window.location.hash = target;
        }
      }
    });
  }

  return NsNavPlugin;
});
